import { render } from "./CoachDetails.vue?vue&type=template&id=ede28cd0&scoped=true"
import script from "./CoachDetails.vue?vue&type=script&lang=js"
export * from "./CoachDetails.vue?vue&type=script&lang=js"

import "./CoachDetails.vue?vue&type=style&index=0&id=ede28cd0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede28cd0"]])

export default __exports__